(() => {
  const initialize = (root) => {
    if (root.dataset.nyonResourcesReady === 'true') return;
    root.dataset.nyonResourcesReady = 'true';
    
  const menuButton = document.querySelector('[data-menu-button]');
  const nav = document.querySelector('[data-primary-nav]');
  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  const pageRoot = root;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealSelectors = [
    '.hero .eyebrow', '.hero h1', '.hero-lede', '.hero-actions', '.hero-media',
    '.topic-chip', '.answer-band__shell > *', '.section-heading > *', '.card',
    '.article-body > *', '.definition', '.evidence-item', '.meta-strip__shell > *',
    '.cta-panel > *'
  ];
  const revealItems = [...new Set(revealSelectors.flatMap((selector) => [...pageRoot.querySelectorAll(selector)]))];
  revealItems.forEach((item, index) => {
    item.classList.add('reveal');
    item.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 65}ms`);
  });
  pageRoot.classList?.add('motion-ready');
  if (!reduceMotion && pageRoot instanceof HTMLElement) void pageRoot.offsetWidth;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const target = entry.target;
        target.classList.add('is-visible');
        if (typeof target.animate === 'function') {
          const delay = parseFloat(getComputedStyle(target).getPropertyValue('--reveal-delay')) || 0;
          const animation = target.animate([
            { opacity: 0, transform: 'translate3d(0, 28px, 0) scale(.992)' },
            { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)' }
          ], { duration: 860, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
          animation.finished.then(() => animation.cancel()).catch(() => {});
        }
        observer.unobserve(entry.target);
      });
    }, { threshold: .06, rootMargin: '4% 0px 4% 0px' });
    requestAnimationFrame(() => requestAnimationFrame(() => revealItems.forEach((item) => observer.observe(item))));
  }

  pageRoot.querySelectorAll('[data-rail]').forEach((rail) => {
    const id = rail.id;
    const controls = [...pageRoot.querySelectorAll(`[data-rail-target="${id}"]`)];
    const updateControls = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      controls.forEach((button) => {
        button.disabled = button.dataset.direction === 'next' ? rail.scrollLeft >= max - 2 : rail.scrollLeft <= 2;
      });
    };
    controls.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.direction === 'next' ? 1 : -1;
        rail.scrollBy({ left: rail.clientWidth * .82 * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', updateControls, { passive: true });
    addEventListener('resize', updateControls);
    updateControls();
  });

  if (!reduceMotion) {
    const media = [...pageRoot.querySelectorAll('.hero-media')];
    let frame = 0;
    const updateMedia = () => {
      frame = 0;
      media.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = (center - window.innerHeight / 2) / Math.max(window.innerHeight, 1);
        item.style.setProperty('--nyon-media-shift', `${Math.max(-6, Math.min(1, distance * -5 - 2.5)).toFixed(2)}%`);
      });
    };
    const scheduleMedia = () => {
      if (frame) return;
      frame = requestAnimationFrame(updateMedia);
    };
    updateMedia();
    addEventListener('scroll', scheduleMedia, { passive: true });
    addEventListener('resize', scheduleMedia);
  }

  const tocLinks = [...pageRoot.querySelectorAll('.toc a[href^="#"]')];
  const tocSections = tocLinks.map((link) => pageRoot.querySelector(link.getAttribute('href'))).filter(Boolean);
  if (tocLinks.length && tocSections.length && 'IntersectionObserver' in window) {
    const tocObserver = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      tocLinks.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`));
    }, { rootMargin: '-18% 0px -68% 0px', threshold: [0, .2, .6] });
    tocSections.forEach((section) => tocObserver.observe(section));
  }

  };
  const run = () => document.querySelectorAll('.nyon-pr').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
